import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck, FileText, FlaskConical, CalendarClock } from "lucide-react";
import { http } from "../lib/api";

const ICON = { auto_invoice: FileText, trial: FlaskConical, option_end: CalendarClock };

export function SuperNotifications() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  const load = () => http.get("/superadmin/notifications").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!d || !d.items.length) return null;
  const open = async (n) => { if (!n.read) await http.post(`/superadmin/notifications/${n.id}/read`); if (n.link) nav(n.link); else load(); };
  return (
    <div className="bg-white border border-slate-200 rounded-md p-5" data-testid="super-notifications">
      <div className="flex items-center gap-2 mb-3">
        <Bell className="h-5 w-5" /><h2 className="font-display font-bold text-lg">Notifications</h2>
        {d.unread > 0 && <span className="min-w-[22px] h-5 px-1.5 rounded-full bg-rose-600 text-white text-[11px] font-bold grid place-items-center" data-testid="super-notifications-unread">{d.unread}</span>}
        {d.unread > 0 && <button onClick={() => http.post("/superadmin/notifications/all/read").then(load)} className="ml-auto inline-flex items-center gap-1 text-xs font-semibold text-slate-600 hover:text-slate-900" data-testid="super-notifications-read-all"><CheckCheck className="h-4 w-4" />Tout marquer comme lu</button>}
      </div>
      <div className="divide-y divide-slate-100 max-h-80 overflow-y-auto">
        {d.items.map((n) => { const I = ICON[n.kind] || Bell; return (
          <button key={n.id} onClick={() => open(n)} className={`w-full text-left flex items-start gap-3 px-2 py-3 rounded transition-colors hover:bg-slate-50 ${n.read ? "opacity-60" : ""}`} data-testid={`super-notification-${n.id}`}>
            <I className={`h-4 w-4 mt-0.5 shrink-0 ${n.read ? "text-slate-400" : "text-[#C9962E]"}`} />
            <span className="flex-1 min-w-0"><span className={`block text-sm ${n.read ? "" : "font-semibold"}`}>{n.title}</span><span className="block text-xs text-slate-500">{n.text}</span></span>
            <span className="text-[11px] text-slate-400 shrink-0">{new Date(n.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
          </button>
        ); })}
      </div>
    </div>
  );
}
